import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface StyledButtonProps {
  selected?: boolean;
}

export const Header = styled('header')(({ theme }) => ({
  width: '100%',
  top: '0',
  left: '0',
  position: 'absolute',
  height: '84px',
  background: theme.colors.darkBlue,
  zIndex: '997',
  padding: '0 20px',
}));

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  position: 'relative',
  gridTemplateColumns: '1fr minmax(160px, 1fr) 1fr',
}));

export const Inner = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
});

export const LogoBox = styled('div')({
  margin: '0 auto',
  zIndex: '1',
  justifySelf: 'center',
});

export const ButtonsBox = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  justifySelf: 'end',
  alignItems: 'center',
  gap: '20px',
});

export const LogoutButton = styled('button')({
  border: '2px solid #1CFF47',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: '700',
  color: '#FFFFFF',
  fontFamily: "'Montserrat', sans-serif",
  width: 'auto',
  height: '34px',
  textTransform: 'uppercase',
  background: 'transparent',
  outline: 'none',
});

export const BackToGameZoneLink = styled(Link)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  border: '0',
  background: 'transparent',
  outline: '0',
  cursor: 'pointer',
  textDecoration: 'none',
  justifySelf: 'start',
});

export const BackToPrevPage = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  border: '0',
  background: 'transparent',
  outline: '0',
  cursor: 'pointer',
  textDecoration: 'none',
  justifySelf: 'start',
});

export const ChevronLeft = styled('img')({
  marginRight: '8px',
});

export const BackToGameZoneText = styled('p')(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.white,
}));
export const NHLLogo = styled('img')({
  marginRight: '5px',
});

export const ProfileButton = styled('button')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#FFFFFF',
  fontSize: '17px',
  fontWeight: '400',
  background: 'transparent',
  border: '0',
  outline: '0',
  marginRight: '30px',
  cursor: 'pointer',

  span: {
    marginRight: '5px',
  },
});

export const NavWrapper = styled('div')({
  width: '100%',
  height: '62px',
  paddingTop: '15px',
  backgroundColor: '#181818',
});

export const NavInner = styled('div')<{ items: number }>(({ items }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${items}, 1fr)`,
  gridTemplateRows: '1fr',
  gridColumnGap: '2px',
  gridRowGap: '2px',
  width: '100%',
  maxWidth: '660px',
  margin: '0 auto',
}));

export const StyledButton = styled(Link)<StyledButtonProps>(
  ({ theme, selected }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    background: selected
      ? '#999999'
      : 'linear-gradient(180deg, #323232 0%, #212121 100%)',
    textTransform: 'uppercase',
    fontSize: '14px',
    color: theme.colors.white,
    textDecoration: 'none',
    justifyContent: 'center',
    height: '45px',
    borderRadius: '0',
    'svg path': {
      fill: selected ? 'white' : '#BDBDBD',
    },

    ':first-child': {
      borderRadius: '10px 0 0 0',
    },
    ':last-child': {
      borderRadius: '0 10px 0 0',
    },
  })
);

export const ImageLogo = styled('img')({
  width: '177px',
  height: '54px',
});
